import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CATEGORY_TREE_FEATURE_KEY, CategoryTreeState } from './category-tree.reducer';

// Lookup the 'CategoryTree' feature state managed by NgRx
export const selectCategoryTreeState = createFeatureSelector<CategoryTreeState>(CATEGORY_TREE_FEATURE_KEY);

export const selectCategoryTreeLoaded = createSelector(
  selectCategoryTreeState,
  (state: CategoryTreeState) => state.loaded
);

export const selectCategoryTreeError = createSelector(
  selectCategoryTreeState,
  (state: CategoryTreeState) => state.error
);

export const selectCategoryTreeCategory = createSelector(
  selectCategoryTreeState,
  (state: CategoryTreeState) => state.categories
);
